export function gettext(key: string): string {
  return key;
}
